module.exports = __webpack_public_path__ + "img/banner.dd2a4e33.png";